import omit from "lodash/omit";
import qs from "qs";
import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";

import { Filter, getFilterKeys } from "~/features/filter";

import { positionsDirectoryFilterFields } from "./fields";

const DEFAULT_STATUS = "active";

const PositionsDirectoryFilter = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const fields = useMemo(() => positionsDirectoryFilterFields(t), [t]);

  // По умолчанию фильтр по статусу = active (как в старой логике страницы):
  // подставляем его в URL при первом входе, если статус не задан явно.
  useEffect(() => {
    const params = location.search ? qs.parse(location.search.slice(1)) : {};
    if (!params.status) {
      history.replace({
        search: qs.stringify({ ...params, status: DEFAULT_STATUS }),
      });
    }
  }, []);

  // Сброс фильтра также возвращает статус active — так работала
  // отмена в старом фильтре (defaultValues со status = active).
  const handleReset = () => {
    const params = location.search ? qs.parse(location.search.slice(1)) : {};
    const rest = omit(params, [...getFilterKeys(fields), "page"]);
    history.replace({
      search: qs.stringify({ ...rest, status: DEFAULT_STATUS }),
    });
  };

  return (
    <Filter.Root
      fields={fields}
      alwaysShow
      columns={7}
      onReset={handleReset}
    />
  );
};

export default PositionsDirectoryFilter;
